var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlfaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 20.2127H19.774V23.4146H4V20.2127ZM8.692 12.6556H14.914L15.964 15.8751H19.414L14.758 2.34146C14.308 1.04195 13.786 0 12.004 0C10.222 0 9.676 1.02439 9.208 2.34146L4.336 15.8693H7.57L8.692 12.6556ZM11.848 3.5122H11.926L14.02 9.95122H9.64L11.848 3.5122Z",
    fill: "#EF3124"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlfaIcon);
export default __webpack_public_path__ + "static/media/alfa-icon.51986477eebfa3c4372e4b1bf4362298.svg";
export { ForwardRef as ReactComponent };